import { TCollection, TEntity } from '@ws/shared/types';

export function isCollection(node: TEntity): node is TCollection {
  return node.type === 'collection';
}
